import { createSlice } from "@reduxjs/toolkit";
import { tokenKey, refreshTokenKey, expirationKey } from "../api/OAuth";
import { clearUserProfile } from "../utils/userProfileUtils";

export const userIsAuthenticatedSlice = createSlice({
  name: "userIsAuthenticated",
  initialState: {
    userIsAuthenticated: localStorage.getItem(tokenKey) ? true : false,
  },
  reducers: {
    setUserAuthenticated: (state) => {
      state.userIsAuthenticated = true;
    },
    setUserUnauthenticated: (state) => {
      state.userIsAuthenticated = false;
      localStorage.removeItem(tokenKey);
      localStorage.removeItem(refreshTokenKey);
      localStorage.removeItem(expirationKey);
      clearUserProfile();
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserAuthenticated, setUserUnauthenticated } =
  userIsAuthenticatedSlice.actions;

export default userIsAuthenticatedSlice.reducer;
